import ChevronRight from '@mui/icons-material/ChevronRight';
import { List, ListItem, ListItemButton, ListItemText } from '@mui/material';
import { Box } from '@mui/system';
import React, { FC, useEffect, useState } from 'react';

interface SideNavigationComponentProps {
}

interface SideNavigationComponentProps {
    items: SideNavigationItem[];
}

export interface SideNavigationItem {
    id: string;
    label: string;
}

const SideNavigationComponent: FC<SideNavigationComponentProps> = ({
                                                                       items,
                                                                   }) => {
    const [activeItem, setActiveItem] = useState(items[0]?.id || '');

    const handleItemClick = (item: SideNavigationItem) => {
        const element = document.getElementById(item.id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    useEffect(() => {
        const handleScroll = () => {
            const sections = items.map((item) => ({
                id: item.id,
                element: document.getElementById(item.id),
            })).filter((section) => section.element);

            let currentSection = sections[0]?.id;
            const visibleSections = sections.filter((section) => {
                const rect = section.element!.getBoundingClientRect();
                return rect.top <= window.innerHeight * 0.2;
            });

            if (visibleSections.length > 0) {
                currentSection = visibleSections[visibleSections.length - 1].id;
            }

            setActiveItem(currentSection || items[0]?.id || '');
        };

        let ticking = false;
        const throttledScroll = () => {
            if (!ticking) {
                requestAnimationFrame(() => {
                    handleScroll();
                    ticking = false;
                });
                ticking = true;
            }
        };

        handleScroll();
        window.addEventListener('scroll', throttledScroll);
        return () => window.removeEventListener('scroll', throttledScroll);
    }, [items]);

    return (
        <Box
            data-testid="SideNavigationComponent"
            sx={{
                width: '100%',
                maxWidth: 360,
                position: 'sticky',
                top: 24,
                alignSelf: 'flex-start',
            }}
        >
            <List disablePadding>
                {items.map((item) => (
                    <ListItem key={item.id} disablePadding>
                        <ListItemButton
                            selected={activeItem === item.id}
                            onClick={() => handleItemClick(item)}
                            sx={{
                                py: 1,
                                px: 3,
                                mb: 1,
                                backgroundColor: 'grey.50',
                                '&:hover': {
                                    backgroundColor: 'grey.100',
                                },
                                '&.Mui-selected': {
                                    backgroundColor: 'primary.50',
                                    color: 'primary.main',
                                },
                            }}
                        >
                            <ListItemText
                                primary={item.label}
                                slotProps={{
                                    primary: {
                                        fontWeight: activeItem === item.id ? 600 : 400,
                                    },
                                }}
                            />
                            <ChevronRight />
                        </ListItemButton>
                    </ListItem>
                ))}
            </List>
        </Box>
    );
};

export default SideNavigationComponent;
SideNavigationComponent.defaultProps = {};
